import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { IRegEdSubmissionAnnotation } from './types';

export const useRegEdAnnotationDownloadMutation = ({
	onError,
}: {
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) => {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({
			parentId,
			approvalRequestId,
			annotation,
			impersonationContext,
		}: {
			parentId: string;
			approvalRequestId: string;
			annotation: IRegEdSubmissionAnnotation;
			impersonationContext?: Api.IImpersonationContext;
		}) =>
			new Promise<void>((resolve, reject) => {
				userSession.webServiceHelper.callWebServiceRawResponse(
					Api.ImpersonationBroker.composeApiUrl({
						impersonationContext,
						queryParams: { parentId, approvalRequestId, annotationId: annotation.id! },
						urlPath: 'compliance/regEd/submissions/annotations',
					}),
					'GET',
					null,
					response => {
						response
							.blob()
							.then(blob => {
								const url = window.URL.createObjectURL(blob);
								const a = document.createElement('a');
								a.href = url;
								a.download = annotation.fileName || 'reviewer-annotation.pdf';
								document.body.appendChild(a);
								a.click();
								a.remove();
								window.URL.revokeObjectURL(url);
								resolve();
							})
							.catch(reject);
					},
					error => reject(error)
				);
			}),
		onError,
	});
};
